import { FlaskConical, Rocket, PawPrint } from "lucide-react";
import { Reveal } from "./Reveal";
import { PaintSplat } from "./PaintSplat";

const CHAPTERS = [
  {
    no: "01",
    icon: FlaskConical,
    accent: "text-[#2dd4bf]",
    hover: "group-hover:text-[#2dd4bf]",
    border: "group-hover:border-[#2dd4bf]/50",
    hex: "#2dd4bf",
    underline: "/paint/ul_teal.webp",
    title: "Part studio, part lab.",
    body: "Silver Schnauzer Studios sits at the intersection of engineering and design. We ship production software and craft the brand systems that wrap around it — no hand-offs, no gaps.",
  },
  {
    no: "02",
    icon: Rocket,
    accent: "text-[#ff7a2f]",
    hover: "group-hover:text-[#ff7a2f]",
    border: "group-hover:border-[#ff7a2f]/50",
    hex: "#ff7a2f",
    underline: "/paint/ul_orange.webp",
    title: "Design that ships.",
    body: "Pixels are only worth something once they run. Every interface we draw is built to be built — accessible, performant, and obsessively detailed down to the last transition.",
  },
  {
    no: "03",
    icon: PawPrint,
    accent: "text-[#ff6b6b]",
    hover: "group-hover:text-[#ff6b6b]",
    border: "group-hover:border-[#ff6b6b]/50",
    hex: "#ff6b6b",
    underline: "/paint/ul_coral.webp",
    title: "Small pack, sharp teeth.",
    body: "A tight senior team means you work directly with the people making the decisions. Fast feedback, honest opinions, and work on which we're proud to put our name.",
  },
];

export const Manifesto = () => (
  <section id="about" className="relative py-28 md:py-40 overflow-hidden" data-testid="about-section">
    <PaintSplat color="teal2" className="w-[460px] h-[460px] -top-16 -right-24" rotate={20} opacity={0.5} from={70} to={-70} />
    <PaintSplat color="coral" className="w-[400px] h-[400px] -bottom-16 -left-24" rotate={190} opacity={0.42} from={-60} to={60} />
    <div className="mx-auto max-w-[1400px] px-6 md:px-10 relative z-10">
      <Reveal className="mb-20 md:mb-28 max-w-3xl">
        <span className="font-mono-accent text-[11px] tracking-[0.3em] uppercase text-[#8b8b8b]">
          [ 00 ] &nbsp;The Manifesto
        </span>
        <h2 className="font-display font-medium tracking-tighter text-4xl md:text-6xl leading-[1.02] mt-6">
          We treat every project like it carries our name — because it does.
        </h2>
      </Reveal>

      <div className="border-t border-[#242424]">
        {CHAPTERS.map((c, i) => (
          <Reveal
            key={c.no}
            delay={i * 0.08}
            className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 py-12 md:py-16 border-b border-[#242424] group"
            data-testid={`manifesto-chapter-${c.no}`}
          >
            <div className="md:col-span-3">
              <span className="font-mono-accent text-5xl md:text-7xl text-[#fafafa] leading-none">
                {c.no}
              </span>
              <img
                src={c.underline}
                alt=""
                aria-hidden
                className="mt-3 h-3.5 md:h-5 w-32 md:w-44 object-contain object-left origin-left transition-transform duration-500 group-hover:scale-x-110"
              />
            </div>
            <h3 className="md:col-span-4 font-display text-2xl md:text-3xl tracking-tight leading-tight">
              {c.title}
            </h3>
            <p className="md:col-span-5 text-[#9a9a9a] text-base md:text-lg leading-relaxed">
              {c.body}
            </p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
